import { render, staticRenderFns } from "./MultifactorSignin.vue?vue&type=template&id=98f870ce&scoped=true&"
import script from "./MultifactorSignin.vue?vue&type=script&lang=js&"
export * from "./MultifactorSignin.vue?vue&type=script&lang=js&"
import style0 from "./MultifactorSignin.vue?vue&type=style&index=0&id=98f870ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f870ce",
  null
  
)

export default component.exports